export enum enumMarineInsuranceChangesType {
  BILL_NUMBER_CHANGED = 1,
  DETAILS_CHANGED = 2,
  ALL = 3,
}
